import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { BASE_URL } from "../../global";
import FormPrint from "./formPrint";
import { Button, Toolbar } from "@mui/material";
import axios from "axios";
import DownloadPdfLoaderModal from "../../utils/components/downloadPdfLoader";
import { generatePDF1 } from "./print";

// Helper to prepare form data by fetching necessary info
const prepareFormData = async (id, templateId) => {
  const [reportRes, templateRes] = await Promise.all([
    axiosWithToken.get(`${BASE_URL}reportValues/${id}`),
    axiosWithToken.get(`${BASE_URL}templates/${templateId}`)
  ]);

  const reportData = reportRes.data[0];
  const templateData = templateRes.data[0];

  const templateValues = JSON.parse(reportData.templateValues || "{}");

  const inputFields = await axios.get(templateData?.url).then(res => res.data);

  const stateKeyArrayBase = [
    "competentPerson", "reportNumber", "reportDate", "factoryId", "shopId",
    "equipmentId", "totalTest", "capacity", "renewalInformation ",
    "inspectionDate ", "certificateValidity ", "inspectionDate",
    "utrasonicTestDate", "hydraulicTestDate", "internalTestDate",
    "internalExaminationDueDate", "certificateValidityDate", "renewalInformation",
    "certificateValidity", "totaltest", "tagNumber"
  ];

  const stateKeyArray = templateData?.name === "Form13"
    ? [...stateKeyArrayBase, "Occupier", "location13"]
    : stateKeyArrayBase;

  // Filter out fields which are already part of state keys
  const filteredInputFields = inputFields.filter(
    (field) => !stateKeyArray.includes(field.stateKey)
  );
  // Fetch additional lookup data
  const [factoryList, shopList, productList, competentData] = await Promise.all([
    axiosWithToken.get(BASE_URL + `clients`).then(res => res.data),
    axiosWithToken.get(BASE_URL + `shops`).then(res => res.data),
    axiosWithToken.get(BASE_URL + `products`).then(res => res.data),
    templateValues?.competentPerson
      ? axiosWithToken.get(BASE_URL + `competents/${templateValues?.competentPerson}`).then(res => res.data?.[0])
      : Promise.resolve(null)
  ]);

  return {
    formInfo: templateData,
    inputStates: templateValues,
    filteredInputFields,
    Factory: factoryList,
    Shop: shopList,
    Product: productList,
    selectedOption: competentData,
  };
};

const MultiplePrintForm = () => {
  const location = useLocation();
  const [ids, setIds] = useState([]);
  const [FormData, setFormData] = useState([]);
  const [downloadPdfloading, setDownloadPdfloading] = useState(false);

  // Fetch form data for given ids
  const fetchFormData = () => {
    try {
      if (ids.length === 0) return;
      let SQLQuery = {
        query: `SELECT id, templateId FROM reportValues WHERE id IN (${ids.join(
          ","
        )}) ORDER BY id DESC`,
      };

      axiosWithToken.post(BASE_URL + `dynamic`, SQLQuery).then((res) => {
        let data = res.data;
        setFormData(data);
      });
    } catch (e) {
      console.log("Failed to fetch checklist template: ", e);
    }
  };

  useEffect(() => {
    if (ids?.length > 0) fetchFormData();
  }, [ids]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const idsParam = searchParams.get("ids");
    if (idsParam) {
      const idsArray = idsParam.split(",").map((id) => parseInt(id)).filter((id) => !isNaN(id));
      setIds(idsArray);
    }
  }, [location.search]);

  // Handle multiple PDF downloads sequentially
  const handleMultipleDownload = async () => {
    if (FormData.length === 0) return;

    setDownloadPdfloading(true);
    for (const item of FormData) {
      const { id, templateId } = item;
      try {
        const data = await prepareFormData(id, templateId);
        await generatePDF1(
          data.formInfo,
          data.inputStates,
          data.filteredInputFields,
          data.Factory,
          data.Shop,
          data.Product,
          data.selectedOption,
          true // silent mode if your function supports it
        );
      } catch (err) {
        console.error(`Failed to generate PDF for id ${id}:`, err);
      }
    }
    setDownloadPdfloading(false);
  };

  return (
    <>
      <Toolbar
            style={{
              padding: "0px",
              overflow: "auto",
              display: "flex",
              justifyContent: "end",
            }}
          >
            <Button
              variant="contained"
              size="small"
              sx={{ marginRight: "20px" }}
              onClick={handleMultipleDownload}
              disabled={downloadPdfloading || FormData.length === 0}
            >
              Multiple Report Print
            </Button>
          </Toolbar>
    <div>
      {FormData?.sort((a, b) => a.id - b.id)?.map((ele) => (
          <div key={ele.id}>
            <FormPrint
            selectedFormID={ele?.id}
            selectedTemplateID={ele?.templateId}
            />
            
          </div>
        ))}
    </div>
  
    {downloadPdfloading && (
        <DownloadPdfLoaderModal loading={downloadPdfloading} name={"Pdf"} />
      )}
    </>
  );
};

export default MultiplePrintForm;
